module.exports = __webpack_public_path__ + "static/media/bf6.20dc64fe.png";